import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./manageSource.module.scss";
import { fetchDataSource } from "../../../../actions/dataSourceInspector";
import Mappings from "./mappings";
import EmptyMessage from "../../../ui/emptyMessage";
import ReactJson from "react-json-view";
import { Grid } from "semantic-ui-react";

interface ManageSourceProps {
  openManageSource: boolean;
  account: any;
}

const ManageSource: React.FC<ManageSourceProps> = ({ openManageSource, account }) => {
  const dispatch = useDispatch();
  const loadingMappings = useSelector((state: any) => state.dataSourceInspector.loading);
  const items = useSelector((state: any) => state.dataSourceInspector.items);
  const [selectedEntity, setSelectedEntity] = useState<any>(null);

  useEffect(() => {
    dispatch(fetchDataSource({ accountId: account.id }));
  }, [dispatch, account.id]);

  useEffect(() => {
    if (!loadingMappings && items?.length > 0 && !selectedEntity) {
      setSelectedEntity(items[0]);
    }
  }, [loadingMappings, items, selectedEntity]);

  if (!openManageSource) return null;

  return (
    <div className={styles.subContainer}>
      {loadingMappings && <div>Fetching all connected sources...</div>}

      {!loadingMappings && items?.length === 0 && (
        <div className={styles.emptyContainer}>
          <EmptyMessage
            width="auto"
            image="/images/dataSource/empty.svg"
            heading="No content source found!"
            message=""

          />
        </div>
      )}

      {!loadingMappings && items?.length > 0 && (
        <Grid>
          <Grid.Row columns={2} stretched>
            <Grid.Column width={8}>
              <Mappings onEntitySelection={setSelectedEntity} />
            </Grid.Column>

            <Grid.Column width={8}>
              {selectedEntity?.metadata ? (
                <div className={styles.jsonViewer}>
                  <ReactJson src={selectedEntity.metadata} name={false} collapsed={false} />
                </div>
              ) : (
                <div>No metadata available</div>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
    </div>
  );
};

export default ManageSource;
